export const environment = {
  production: true,
  buildId: '3043474690620091',
  configFile: 'config.json',
};
